import { createContent } from './create'
import { deleteContent } from './delete'
import { readContent } from './read'
import { updateContent } from './update'

export const content = {
  create: createContent,
  delete: deleteContent,
  readSingle: readContent,
  update: updateContent,
}
